
export const SET_MSG = 'INSS_MSG';
export const SET_EDITAR = 'INSS_EDITAR';
export const SET_LISTA = 'INSS_EDITAR';
export const SET_BOLETINS = 'INSS_BOLETINS';
export const SET_INSS = 'INSS_INSS';